import { WorkoutType } from '@goatsports/core/data-access';

export const WorkoutTypeNames = {
  Unknown: 'Unknown',
  Gym: 'Gym',
  Home: 'Home',
  Outdoor: 'Outdoor',
  Arthritis: 'Arthritis Training',
  Senior: 'Senior Training',
  Mindfulness: 'Yoga & Mindfulness',
  Rest: 'Rest',
  Sports: 'Sports',
  Cardio: 'Cardio',
} as const;
